var _a, _b, _c;
import { __assign, __spreadArray } from "tslib";
import * as moment from 'moment-timezone';
import { priorities, weekFirstPriorities } from './EventsPriority';
import WeekStartersEnum from '../../../../enums/WeekStartersEnum';
import MomentEnum from '../../../../enums/MomentEnum';
import EventTypes from '../../../../enums/EventTypesEnum';
import { CalendarCellTimes } from 'wix-ui-tpa/dist/src/components/CalendarCell/types';
export var getStartAndEndMonthDates = function (dateObject) {
    var start = moment(dateObject).startOf(MomentEnum.monthString).valueOf();
    var end = moment(dateObject).endOf(MomentEnum.monthString).valueOf();
    return { start: start, end: end };
};
export var getNextMonthFirstWeekDay = function (dateObject, weekStarter) {
    var nextMonthFirstDate = getNextMonthFirstDate(dateObject).format(MomentEnum.dayOfWeek);
    return getDayByWeekStarter(nextMonthFirstDate, weekStarter);
};
export var getDayByWeekStarter = function (day, weekStarter) {
    var intDay = parseInt(day, 10);
    return dayByWeekStarterGetter[weekStarter](intDay);
};
export var getMonthFirstWeekDay = function (dateObject, weekStarter) {
    var firstDay = moment(dateObject)
        .startOf(MomentEnum.monthString)
        .format(MomentEnum.dayOfWeek);
    return getDayByWeekStarter(firstDay, weekStarter);
};
export var getNextMonthFirstDate = function (dateObject) {
    return moment(dateObject).add(1, MomentEnum.months).startOf(MomentEnum.monthString);
};
export var dayByWeekStarterGetter = (_a = {},
    _a[WeekStartersEnum.Sunday] = function (day) { return day; },
    _a[WeekStartersEnum.Monday] = function (day) { return dayByWeekStarter(day, 0, 6, function () { return --day; }); },
    _a[WeekStartersEnum.Saturday] = function (day) {
        return dayByWeekStarter(day, 6, 0, function () { return ++day; });
    },
    _a);
export var dayByWeekStarter = function (day, edgeCaseDay, edgeCaseDayReplacement, accumulator) {
    return day === edgeCaseDay ? edgeCaseDayReplacement : accumulator();
};
export var getMonthDaysWithEvents = function (_a) {
    var dateObject = _a.dateObject, mutableDates = _a.mutableDates, _b = _a.weekStarter, weekStarter = _b === void 0 ? WeekStartersEnum.Sunday : _b, _c = _a.isSorted, isSorted = _c === void 0 ? true : _c;
    var dateIndex = moment(dateObject).startOf(MomentEnum.monthString);
    var dateLimit = getNextMonthFirstDate(dateObject);
    return getDatesWithEvents({
        dateIndex: dateIndex,
        dateLimit: dateLimit,
        mutableDates: mutableDates,
        weekStarter: weekStarter,
        isSorted: isSorted,
    });
};
export var getDatesWithEvents = function (_a) {
    var dateIndex = _a.dateIndex, dateLimit = _a.dateLimit, mutableDates = _a.mutableDates, weekStarter = _a.weekStarter, _b = _a.isSorted, isSorted = _b === void 0 ? true : _b;
    var datesToReturn = {};
    var eventsAmount = 0;
    while (dateIndex.isBefore(dateLimit)) {
        var date = dateIndex.format(MomentEnum.yearMonthDay);
        datesToReturn[date] = getEventsByDate({
            mutableDates: mutableDates,
            date: date,
            weekStarter: weekStarter,
            isSorted: isSorted,
        });
        if (datesToReturn[date].length) {
            eventsAmount += datesToReturn[date].length;
        }
        dateIndex.add(1, MomentEnum.days);
    }
    return { datesToReturn: datesToReturn, eventsAmount: eventsAmount };
};
export var getEventsByDate = function (_a) {
    var mutableDates = _a.mutableDates, date = _a.date, weekStarter = _a.weekStarter, isSorted = _a.isSorted;
    var eventsByDate = mutableDates[date];
    if (!eventsByDate) {
        return [];
    }
    if (!isSorted) {
        return eventsByDate;
    }
    var weekFirst = isWeekFirst(date, weekStarter);
    var weekend = isWeekEnd(date, weekStarter);
    var daysTillWeekend = getDaysTillWeekend(date, weekStarter);
    var compare = weekFirst
        ? function (event1, event2) { return isEvent1After2(event1, event2, weekFirstPriorities); }
        : function (event1, event2) { return isEvent1After2(event1, event2, priorities); };
    eventsByDate = insertionSort(eventsByDate, compare);
    var eventsToReturn = eventsByDate.map(function (event, eventIndex) {
        return event
            ? eventUpdaters[event.type]({
                event: event,
                mutableDates: mutableDates,
                date: date,
                eventIndex: eventIndex,
                weekFirst: weekFirst,
                weekend: weekend,
                daysTillWeekend: daysTillWeekend,
            })
            : { id: eventIndex, type: EventTypes.Null };
    });
    return eventsToReturn;
};
export var isWeekFirst = function (date, weekStarter) {
    var momentObj = moment(date).locale('en');
    return (momentObj.format(MomentEnum.fullWeekDayName).toLocaleLowerCase() ===
        weekStarter);
};
export var isWeekEnd = function (date, weekStarter) {
    var momentObj = moment(date).add(1, MomentEnum.days);
    return isWeekFirst(momentObj, weekStarter);
};
export var isWeekSecond = function (date, weekStarter) {
    var momentObj = moment(date).locale('en');
    return (momentObj
        .subtract(1, MomentEnum.days)
        .format(MomentEnum.fullWeekDayName)
        .toLocaleLowerCase() === weekStarter);
};
export var bubbleSort = function (array, compare) {
    var _a;
    var mutableArray = __spreadArray([], array, true);
    for (var _i = 0, mutableArray_1 = mutableArray; _i < mutableArray_1.length; _i++) {
        var item = mutableArray_1[_i];
        for (var j = 0; j < mutableArray.length - 1; j++) {
            if (compare(mutableArray[j], mutableArray[j + 1])) {
                _a = [
                    mutableArray[j + 1],
                    mutableArray[j],
                ], mutableArray[j] = _a[0], mutableArray[j + 1] = _a[1];
            }
        }
    }
    return mutableArray;
};
export var insertionSort = function (array, compare) {
    var mutableArray = __spreadArray([], array, true);
    for (var i = 1; i < mutableArray.length; i++) {
        var key = mutableArray[i];
        var j = i - 1;
        while (j >= 0 && compare(mutableArray[j], key)) {
            mutableArray[j + 1] = mutableArray[j];
            j--;
        }
        mutableArray[j + 1] = key;
    }
    return mutableArray;
};
export var isEvent1After2 = function (event1, event2, priorityDictionary) {
    var type1 = event1 ? event1.type : EventTypes.Null;
    var type2 = event2 ? event2.type : EventTypes.Null;
    var priority = type1 + type2;
    return priorityDictionary[priority](event1, event2);
};
export var eventUpdaters = (_b = {},
    _b[EventTypes.Default] = function (_a) {
        var event = _a.event;
        return event;
    },
    _b[EventTypes.AllDay] = function (_a) {
        var event = _a.event;
        return event;
    },
    _b[EventTypes.MultiDay] = function (_a) {
        var event = _a.event, mutableDates = _a.mutableDates, date = _a.date, eventIndex = _a.eventIndex, weekend = _a.weekend, daysTillWeekend = _a.daysTillWeekend;
        return updateNextDates({
            event: event,
            mutableDates: mutableDates,
            date: date,
            eventIndex: eventIndex,
            originEventId: event.id,
            weekend: weekend,
            daysTillWeekend: daysTillWeekend,
        });
    },
    _b[EventTypes.AllDayMultiDay] = function (_a) {
        var event = _a.event, mutableDates = _a.mutableDates, date = _a.date, eventIndex = _a.eventIndex, weekend = _a.weekend, daysTillWeekend = _a.daysTillWeekend;
        return updateNextDates({
            event: event,
            mutableDates: mutableDates,
            date: date,
            eventIndex: eventIndex,
            originEventId: event.id,
            weekend: weekend,
            daysTillWeekend: daysTillWeekend,
        });
    },
    _b[EventTypes.Filler] = function (_a) {
        var event = _a.event, mutableDates = _a.mutableDates, date = _a.date, eventIndex = _a.eventIndex, weekFirst = _a.weekFirst, weekend = _a.weekend, daysTillWeekend = _a.daysTillWeekend;
        return updateFiller({
            event: event,
            mutableDates: mutableDates,
            date: date,
            eventIndex: eventIndex,
            weekFirst: weekFirst,
            weekend: weekend,
            daysTillWeekend: daysTillWeekend,
        });
    },
    _b);
export var updateFiller = function (_a) {
    var event = _a.event, mutableDates = _a.mutableDates, date = _a.date, eventIndex = _a.eventIndex, weekFirst = _a.weekFirst, weekend = _a.weekend, daysTillWeekend = _a.daysTillWeekend;
    var mutableFiller = __assign({}, event);
    mutableFiller.isWeekend = weekend;
    mutableFiller.daysTillWeekend = daysTillWeekend;
    if (weekFirst) {
        mutableFiller.isNextWeekFirstFiller = true;
        updateNextDates({
            event: event,
            mutableDates: mutableDates,
            date: date,
            eventIndex: eventIndex,
            originEventId: event.originEventId,
        });
    }
    mutableFiller.isLastFiller = isLastEventDate({
        eventEndDate: event.endDate,
        date: date,
    });
    return mutableFiller;
};
export var isLastEventDate = function (_a) {
    var eventEndDate = _a.eventEndDate, date = _a.date;
    return moment(eventEndDate).isSame(date, MomentEnum.dayString);
};
export var updateNextDates = function (_a) {
    var event = _a.event, mutableDates = _a.mutableDates, date = _a.date, eventIndex = _a.eventIndex, originEventId = _a.originEventId, _b = _a.weekend, weekend = _b === void 0 ? false : _b, _c = _a.daysTillWeekend, daysTillWeekend = _c === void 0 ? 0 : _c;
    var dateIndex = moment(date);
    while (moment(dateIndex).isBefore(event.endDate, MomentEnum.dayString)) {
        dateIndex = dateIndex.add(1, MomentEnum.days);
        updateDates(mutableDates, dateIndex, eventIndex, originEventId);
    }
    var eventsToReturn = __assign(__assign({}, event), { isWeekend: weekend, daysTillWeekend: daysTillWeekend });
    return eventsToReturn;
};
export var updateDates = function (mutableDates, dateIndex, eventIndex, eventId) {
    var _a;
    var formattedDate = dateIndex.format(MomentEnum.yearMonthDay);
    try {
        var events = __spreadArray([], mutableDates[formattedDate], true);
        var fillerIndex = events.findIndex(function (event) { return event && event.isFiller && event.originEventId === eventId; });
        if (fillerIndex < 0) {
            throw new Error();
        }
        _a = [
            events[eventIndex],
            events[fillerIndex],
        ], events[fillerIndex] = _a[0], events[eventIndex] = _a[1];
        mutableDates[formattedDate] = events;
    }
    catch (error) {
        // console.error(
        //   `Filler is missing on: ${formattedDate} for the multi day event with ID: ${eventId}`,
        // );
    }
};
export var hasAfterFillers = function (beforeFillers, days) {
    return (Object.keys(beforeFillers).length + Object.keys(days).length) % 7 !== 0;
};
var equalizers = {
    object: function (prevProp, nextProp) {
        return JSON.stringify(prevProp) === JSON.stringify(nextProp);
    },
    function: function (prevProp, nextProp) { return true; },
    string: function (prevProp, nextProp) { return prevProp === nextProp; },
    boolean: function (prevProp, nextProp) { return prevProp === nextProp; },
    number: function (prevProp, nextProp) { return prevProp === nextProp; },
};
export var areEqualProps = function (prevProps, nextProps) {
    for (var prop in prevProps) {
        var prevValue = prevProps[prop];
        var nextValue = nextProps[prop];
        try {
            if (!equalizers[typeof prevValue](prevValue, nextValue)) {
                return false;
            }
        }
        catch (error) {
            continue;
        }
    }
    return true;
};
export var getMonthDays = function (_a) {
    var days = _a.days, dateObject = _a.dateObject, daysInserter = _a.daysInserter;
    var daysInMonth = [];
    var currentDay = parseInt(moment().format(MomentEnum.dayOfMonth), 10);
    for (var day in days) {
        var momentDayObject = moment(day);
        var dayMonthNumber = parseInt(momentDayObject.format(MomentEnum.dayOfMonth), 10);
        var now = moment();
        var isCurrentMonth = dateObject.isSame(now, MomentEnum.monthString) &&
            dateObject.isSame(now, MomentEnum.yearString);
        var timeType = getTimeType(dayMonthNumber, currentDay, isCurrentMonth, dateObject);
        var events = days[day];
        daysInMonth.push(
        //@ts-ignore
        daysInserter({ events: events, day: day, timeType: timeType, current: isCurrentMonth }));
    }
    return daysInMonth;
};
export var getTimeType = function (day, currentDay, isCurrentMonth, dateObject) {
    var timeType = '';
    var now = moment();
    if (isCurrentMonth) {
        if (day < currentDay) {
            timeType = CalendarCellTimes.pastDate;
        }
        else if (day === currentDay) {
            timeType = CalendarCellTimes.today;
        }
        else {
            timeType = CalendarCellTimes.futureDate;
        }
    }
    else if (dateObject.isBefore(now)) {
        timeType = CalendarCellTimes.pastDate;
    }
    else {
        timeType = CalendarCellTimes.futureDate;
    }
    return timeType;
};
export var hasPastEvents = function (_a) {
    var days = _a.days;
    var today = moment();
    for (var date in days) {
        var day = days[date];
        if (moment(date).isBefore(today, MomentEnum.dayString) && day.length) {
            return true;
        }
    }
    return false;
};
export var hasTodayEvents = function (_a) {
    var days = _a.days, dateObject = _a.dateObject;
    var now = moment();
    if (!moment(dateObject).isSame(now, MomentEnum.monthString)) {
        return false;
    }
    var today = now.format(MomentEnum.yearMonthDay);
    return Boolean(days[today].length);
};
export var hasFutureEvents = function (_a) {
    var days = _a.days;
    var today = moment();
    for (var day in days) {
        if (moment(day).isAfter(today, MomentEnum.daysString) && days[day].length) {
            return true;
        }
    }
    return false;
};
export var getDateEventsAmount = function (_a) {
    var date = _a.date, dates = _a.dates;
    return dates[date] && dates[date].length;
};
export var getPrevDateWithEvents = function (_a) {
    var date = _a.date, dates = _a.dates;
    var prevDateWithEvents = '';
    var minDiff = Infinity;
    for (var dateIndex in dates) {
        var diff = getDiffAsDays(date, dateIndex);
        if (isSameMonth(date, dateIndex) && diff > 0 && diff < minDiff) {
            minDiff = diff;
            prevDateWithEvents = dateIndex;
        }
    }
    return prevDateWithEvents;
};
export var getNextDateWithEvents = function (_a) {
    var date = _a.date, dates = _a.dates;
    var nextDateWithEvents = '';
    var minDiff = -Infinity;
    for (var dateIndex in dates) {
        var diff = getDiffAsDays(date, dateIndex);
        if (isSameMonth(date, dateIndex) && diff < 0 && diff > minDiff) {
            minDiff = diff;
            nextDateWithEvents = dateIndex;
        }
    }
    return nextDateWithEvents;
};
export var getDiffAsDays = function (date1, date2) {
    return Math.floor(moment.duration(moment(date1).diff(date2)).asDays());
};
export var isSameMonth = function (date1, date2) {
    return moment(date1).isSame(date2, MomentEnum.monthString);
};
export var isAfter = function (beforeDate, afterDate) {
    return moment(afterDate).isAfter(beforeDate, MomentEnum.dayString);
};
export var isLastDateWithEvents = function (_a) {
    var date = _a.date, dates = _a.dates;
    for (var dateIndex in dates) {
        if (isSameMonth(date, dateIndex) && moment(dateIndex).isAfter(date)) {
            return false;
        }
    }
    return true;
};
export var getDaysTillWeekend = function (date, weekStarter) {
    var daysTillWeekend = moment(date)
        .locale('en')
        .endOf(MomentEnum.week)
        .diff(date, MomentEnum.daysString);
    var amount = amountByWeekStarter[weekStarter](daysTillWeekend);
    return amount;
};
var amountByWeekStarter = (_c = {},
    _c[WeekStartersEnum.Sunday] = function (days) { return days; },
    _c[WeekStartersEnum.Monday] = function (days) {
        return dayByWeekStarter(days, 6, 0, function () { return ++days; });
    },
    _c[WeekStartersEnum.Saturday] = function (days) {
        return dayByWeekStarter(days, 0, 6, function () { return --days; });
    },
    _c);
export var isToday = function (date) { return moment().isSame(date, MomentEnum.dayString); };
//# sourceMappingURL=CalendarUtils.js.map